import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  recoverMyPasswordFormContainer,
  titleSuccess
} from './styles/SuccessRecoverPassordPage.style'
import { MdCheckCircleOutline } from 'react-icons/md'

const SuccessRecoverPasswordPage = () => {
  const { t } = useTranslation()

  return (
    <div className={recoverMyPasswordFormContainer}>
      <MdCheckCircleOutline fontSize={60} color='#878787' />
      <h3 className={titleSuccess}>{t('securityCard')['editPasswordSuccess']}!</h3>
    </div>
  )
}

export default SuccessRecoverPasswordPage
